import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58bd52c4&"
import script from "./zPayCameraModal.js?vue&type=script&lang=js&"
export * from "./zPayCameraModal.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=58bd52c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports